var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 8.72705C10.9998 8.72705 8.68164 11.1816 8.68164 14.0453C8.68164 17.0453 11.1362 19.3635 13.9998 19.3635C16.8635 19.3635 19.318 16.9089 19.318 14.0453C19.4544 11.0453 16.9998 8.72705 13.9998 8.72705ZM13.9998 10.7725C15.7726 10.7725 17.2726 12.2725 17.2726 14.0453C17.2726 15.818 15.7726 17.318 13.9998 17.318C12.2271 17.318 10.7271 15.818 10.7271 14.0453C10.7271 12.2725 12.2271 10.7725 13.9998 10.7725Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8178 4.77273V0H7.18146V4.77273H0.363281V24.1364H27.636V4.77273H20.8178ZM9.22692 2.04545H18.7724V4.77273H9.22692V2.04545ZM25.5906 21.9545H2.40874V6.68177H25.5906V21.9545Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.97d0c943745975cb16b6b337e1c3bea2.svg";
export { ForwardRef as ReactComponent };